// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AiChatController from "./ai_chat_controller"
application.register("ai-chat", AiChatController)

import AiPromptController from "./ai_prompt_controller"
application.register("ai-prompt", AiPromptController)

import AutoDismissController from "./auto_dismiss_controller"
application.register("auto-dismiss", AutoDismissController)

import AutomationStepController from "./automation_step_controller"
application.register("automation-step", AutomationStepController)

import BackgroundPickerController from "./background_picker_controller"
application.register("background-picker", BackgroundPickerController)

import BarcodeScannerController from "./barcode_scanner_controller"
application.register("barcode-scanner", BarcodeScannerController)

import BoardController from "./board_controller"
application.register("board", BoardController)

import BugReportController from "./bug_report_controller"
application.register("bug-report", BugReportController)

import BulkActionsController from "./bulk_actions_controller"
application.register("bulk-actions", BulkActionsController)

import CalendarController from "./calendar_controller"
application.register("calendar", CalendarController)

import ChartEditorController from "./chart_editor_controller"
application.register("chart-editor", ChartEditorController)

import ChatScrollController from "./chat_scroll_controller"
application.register("chat-scroll", ChatScrollController)

import ConfirmController from "./confirm_controller"
application.register("confirm", ConfirmController)

import DashboardWidgetController from "./dashboard_widget_controller"
application.register("dashboard-widget", DashboardWidgetController)

import DashboardSummaryController from "./dashboard_summary_controller"
application.register("dashboard-summary", DashboardSummaryController)

import DashboardCustomizeController from "./dashboard_customize_controller"
application.register("dashboard-customize", DashboardCustomizeController)

import ResponsiveDetailsController from "./responsive_details_controller"
application.register("responsive-details", ResponsiveDetailsController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import FileUploadController from "./file_upload_controller"
application.register("file-upload", FileUploadController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import GanttController from "./gantt_controller"
application.register("gantt", GanttController)

import IssueReferenceController from "./issue_reference_controller"
application.register("issue-reference", IssueReferenceController)

import InlineTaskFormController from "./inline_task_form_controller"
application.register("inline-task-form", InlineTaskFormController)

import InlineTaskFieldController from "./inline_task_field_controller"
application.register("inline-task-field", InlineTaskFieldController)

import KanbanController from "./kanban_controller"
application.register("kanban", KanbanController)

import KeyboardController from "./keyboard_controller"
application.register("keyboard", KeyboardController)

import LineItemsController from "./line_items_controller"
application.register("line-items", LineItemsController)

import LoadingController from "./loading_controller"
application.register("loading", LoadingController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import MessageFormController from "./message_form_controller"
application.register("message-form", MessageFormController)

import MentionController from "./mention_controller"
application.register("mention", MentionController)

import ModuleHubController from "./module_hub_controller"
application.register("module-hub", ModuleHubController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import NotificationsController from "./notifications_controller"
application.register("notifications", NotificationsController)

import PosCalculatorController from "./pos_calculator_controller"
application.register("pos-calculator", PosCalculatorController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import SearchableSelectController from "./searchable_select_controller"
application.register("searchable-select", SearchableSelectController)

import SettingsTabsController from "./settings_tabs_controller"
application.register("settings-tabs", SettingsTabsController)

import ScrollStripController from "./scroll_strip_controller"
application.register("scroll-strip", ScrollStripController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import SidebarNavController from "./sidebar_nav_controller"
application.register("sidebar-nav", SidebarNavController)

import SidebarSectionController from "./sidebar_section_controller"
application.register("sidebar-section", SidebarSectionController)

import SignaturePadController from "./signature_pad_controller"
application.register("signature-pad", SignaturePadController)

import SlidePanelController from "./slide_panel_controller"
application.register("slide-panel", SlidePanelController)

import SmsComposeController from "./sms_compose_controller"
application.register("sms-compose", SmsComposeController)

import SortableTableController from "./sortable_table_controller"
application.register("sortable-table", SortableTableController)

import TaskBoardController from "./task_board_controller"
application.register("task-board", TaskBoardController)

import TaskDrawerController from "./task_drawer_controller"
application.register("task-drawer", TaskDrawerController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import TimerController from "./timer_controller"
application.register("timer", TimerController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)
